/** Eine Zeile der Zuordnung Steuersatz → Konto aus den Dialog-Vorgaben (785, `accountByTaxRate`). */
export type KontoZuordnung = { taxRateId: string; bookingAccountId: string | null };

const kontoVon = (satzId: string | null, zuordnung: readonly KontoZuordnung[]): string | null =>
  zuordnung.find((z) => z.taxRateId === satzId)?.bookingAccountId ?? null;

/**
 * KONTO FOLGT DEM STEUERSATZ (Entscheid 768, Plan P16): Beim Wechsel des Steuersatzes bekommt das Konto die Vorbelegung
 * des neuen Satzes — aber nur, wenn es leer ist oder zur Vorbelegung des bisherigen Satzes passte. Ein von Hand anders
 * gewähltes Konto bleibt stehen. Hat der neue Satz keine Zuordnung, wird eine bisherige Vorbelegung damit leer.
 */
export function kontoNachSteuersatz(aktuell: string | null, alterSatzId: string | null, neuerSatzId: string,
  zuordnung: readonly KontoZuordnung[]): string | null {
  const vorbelegt = kontoVon(alterSatzId, zuordnung);
  return aktuell === null || (vorbelegt !== null && aktuell === vorbelegt) ? kontoVon(neuerSatzId, zuordnung) : aktuell;
}
